import * as PopoverPrimitive from '@radix-ui/react-popover';
import type { ComponentProps } from 'react';
import { usePopoverBoundary } from '../helpers/PopoverBoundaryContext';

type PopoverRootProps = ComponentProps<typeof PopoverPrimitive.Root>;

/**
 * Radix Popover.Root の薄いラッパー。
 *
 * `PopoverBoundaryProvider` が `modal` を設定している場合、それを既定値として Radix Root に適用する。
 * これにより、集約 `Popover` を介さず `PopoverRoot` を直接使う検索付きセレクト/カスケーダー
 * （`MultipleSelect`(検索) / `SearchableSingleSelect` / `Searchable*Cascader` 等）も、
 * `FilterPopover` 配下では背景スクロールロック（modal）が揃って効く。
 * 明示的に `modal` prop を渡した場合はそちらを優先する。
 */
export const PopoverRoot = ({ modal, ...props }: PopoverRootProps) => {
  const { modal: ctxModal } = usePopoverBoundary();
  return <PopoverPrimitive.Root modal={modal ?? ctxModal} {...props} />;
};
PopoverRoot.displayName = PopoverPrimitive.Root.displayName;
